module.exports = __webpack_public_path__ + "img/34.10.pH.4e312c01.png";